(() => {
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  function findScrollContainer() {
    // Dawn/Lumin: the scroll container is typically the UL with id "Slider-Gallery-..."
    return (
      document.querySelector('[id^="Slider-Gallery-"]') ||
      document.querySelector('.product__media-list.slider') ||
      document.querySelector('.product__media-list') ||
      null
    );
  }

  function findActiveSlide(container) {
    if (!container) return null;

    // Common "active" markers used by Dawn/Lumin
    return (
      container.querySelector('li.is-active') ||
      container.querySelector('li[aria-current="true"]') ||
      container.querySelector('li[aria-hidden="false"]') ||
      container.querySelector('li[data-media-id]') || // fallback
      null
    );
  }

  function snapToActive() {
    if (!isMobile()) return;

    const container = findScrollContainer();
    if (!container) return;

    const active = findActiveSlide(container);
    if (!active) return;

    // Snap by exact offset (most reliable on mobile Safari)
    const left = active.offsetLeft;

    container.scrollTo({ left, behavior: "auto" });

    // Run again after layout settles (variant swap can reflow twice)
    requestAnimationFrame(() => container.scrollTo({ left: active.offsetLeft, behavior: "auto" }));
    setTimeout(() => container.scrollTo({ left: active.offsetLeft, behavior: "auto" }), 120);
    setTimeout(() => container.scrollTo({ left: active.offsetLeft, behavior: "auto" }), 300);
  }

  // Trigger after variant/color changes
  document.addEventListener("change", (e) => {
    if (e.target.closest("variant-selects, variant-radios, form[action*='/cart/add']")) {
      setTimeout(snapToActive, 0);
      setTimeout(snapToActive, 80);
      setTimeout(snapToActive, 180);
      setTimeout(snapToActive, 360);
    }
  });

  // Also on load / refresh
  window.addEventListener("load", () => setTimeout(snapToActive, 200));
})();
